import React, { ReactElement, useState, useEffect } from 'react';
import styles from './ConnectionAssistantForm.module.less';
import { Form, Divider } from 'antd';
import ConnectionAssistantFormStep1 from './ConnectionAssistantFormStep1';
import ConnectionAssistantFormStep2 from './ConnectionAssistantFormStep2';
import DbDatabase from '../../types/DbDatabase';
import CcxComponentProps from '../../core/CcxComponent';

interface Props extends CcxComponentProps {
    databases?: DbDatabase[];
    users?: string[];
    hosts?: any;
    service?: string;
}

function ConnectionAssistantForm({
    databases,
    users,
    hosts,
    service,
    testId = 'ConnectionAssistantForm',
}: Props): ReactElement {
    const [form] = Form.useForm();
    const [errorFields, setErrorFields] = useState([]);
    const [showConnectionString, setShowConnectionString] =
        useState<boolean>(false);

    const fieldsSetup = {
        step1: [
            {
                name: ['dbuser'],
                testId: 'ConnectionAssistantFormDBUser',
                required: true,
                label: 'Db user',
                placeholder: 'Select a Db user',
                type: 'select',
                options: users
                    ? users?.map((d) => {
                          return {
                              label: d,
                              value: d,
                          };
                      })
                    : [],
            },
            {
                name: ['database'],
                testId: 'ConnectionAssistantFormDatabase',
                required: true,
                label: 'Database name',
                placeholder: 'Select a database',
                type: 'select',
                options: databases
                    ? databases?.map((d) => {
                          return {
                              label: d.databaseName,
                              value: d.databaseName,
                          };
                      })
                    : [],
            },
            {
                name: ['host'],
                testId: 'ConnectionAssistantFormHost',
                required: true,
                label: 'Host',
                placeholder: 'Select a host',
                type: 'select',
                options: hosts
                    ? hosts.dbHosts
                          ?.map((d: any) => {
                              return {
                                  label: `${d.getFqdnPort(
                                      false
                                  )} [${d.getFormattedNodeType()}]`,
                                  value: `${d.getFqdnPort(false)}`,
                              };
                          })
                          .concat(
                              hosts.lbHosts?.map((d: any) => {
                                  return {
                                      label: `${d.getFqdnPort(
                                          false
                                      )} [${d.getFormattedNodeType()}]`,
                                      value: `${d.getFqdnPort(false)}`,
                                  };
                              })
                          )
                    : [],
            },
        ],
    };
    const [fields, setFields] = useState<any>(fieldsSetup);
    const [formData, setFormData] = useState<any>();

    useEffect(() => {
        setFields(fieldsSetup);
    }, [databases, users, hosts]);

    // return boolean if form is valid
    const validateFormStep = async () => {
        let {
            dbuser: account,
            database,
            host: hostPort,
        } = form.getFieldsValue();

        setFormData({ account, database, hostPort });

        account && database && hostPort
            ? setShowConnectionString(true)
            : setShowConnectionString(false);
    };

    return (
        <div className={styles.ConnectionAssistantForm} data-testid={testId}>
            <p>Configure your connection strings for your database</p>

            <strong>Connection settings</strong>

            <Form
                onValuesChange={validateFormStep}
                layout="vertical"
                form={form}
                scrollToFirstError={true}
            >
                <ConnectionAssistantFormStep1
                    fields={fields.step1}
                    errorFields={errorFields}
                />
            </Form>

            <Divider />
            <p>
                <strong>Connection string examples</strong>
            </p>

            {showConnectionString && (
                <ConnectionAssistantFormStep2
                    formData={formData}
                    service={service}
                />
            )}
        </div>
    );
}

export default ConnectionAssistantForm;
